import { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '@/components/Loading';
import AppRoutes from '@/routes';
import { checkAuthorization } from '@/redux/authentication/login/loginSlice';
import { getUserProfile } from '@/redux/profile/profileSlice';
import { getToken } from '@/helpers/handleToken';

function App() {
    const dispatch = useDispatch();

    const isAuthenticated = useSelector((state) => state.authentication.login.isAuthenticated);

    useEffect(() => {
        dispatch(checkAuthorization());
    }, [dispatch]);

    useEffect(() => {
        if (isAuthenticated && getToken()) {
            dispatch(getUserProfile());
        }
    }, [isAuthenticated]);

    return (
        <Suspense fallback={<Loading />}>
            <AppRoutes />
        </Suspense>
    );
}

export default App;
